import { Typography } from '@mui/material';
import { LayoutGridItem } from 'app/layout/LayoutGrid';
import React from 'react';

export const SubHeading = ({ currentItem, index }) => {
  return (
    <LayoutGridItem item key={index}>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: '500 !important',
          color: theme => theme.palette.framework.system.charcoal,
          fontSize: '14px !important',
        }}
      >
        {currentItem?.text?.replace(/&amp;/g, '&')}
      </Typography>
    </LayoutGridItem>
  );
};
